import React, { useState } from 'react';
import { Calendar, CheckCircle, Users, User, Clock, Sparkles, X, ChevronRight } from 'lucide-react';
import { MobileLayout } from '../components/MobileLayout';
import { PianificaPuliziaWizard } from '../components/PianificaPuliziaWizard';
import { ZonePulseWidget } from '../components/ZonePulseWidget';
import { SharingOpportunitiesWidget } from '../components/SharingOpportunitiesWidget';
export function PuliziePage() {
  const [isWizardOpen, setIsWizardOpen] = useState(false);
  const [showTutorial, setShowTutorial] = useState(true);
  const [activeTab, setActiveTab] = useState<'gestione' | 'opportunita'>('gestione');
  // Mock data for upcoming cleanings
  const prossimePulizie = [{
    id: '1',
    property: 'Villa Sunset',
    date: 'Mer 17 Gen',
    time: '11:00 - 15:00',
    status: 'in_corso',
    cleaner: 'Francesca N.',
    cleanerImg: 'https://cdn.magicpatterns.com/uploads/g4qUZyyXcdzW3wf29pvDcz/Screenshot_2026-03-22_alle_16.12.18.png'
  }, {
    id: '2',
    property: 'Villa Sunset',
    date: 'Ven 19 Gen',
    time: '12:00 - 14:30',
    status: 'pianificata',
    cleaner: 'Roberto F.',
    cleanerImg: ''
  }];
  // Mock data for completed cleanings
  const pulizieCompletate = [{
    id: '3',
    property: 'Villa Sunset',
    date: 'Lun 15 Gen',
    duration: '3h 30min',
    cleaner: 'Francesca N.',
    aiScore: 98
  }, {
    id: '4',
    property: 'Villa Sunset',
    date: 'Ven 12 Gen',
    duration: '4h',
    cleaner: 'Roberto F.',
    aiScore: 100
  }];
  return <MobileLayout data-id="element-1666">
      {/* Header */}
      <div className="flex items-center justify-between mb-5" data-id="element-1667">
        <h1 className="text-xl lg:text-2xl font-bold text-foreground" data-id="element-1668">
          Pulizie
        </h1>
      </div>

      {/* Tabs */}
      <div className="flex gap-1 bg-muted rounded-lg p-1 mb-6 border border-border" data-id="element-1669">
        <button onClick={() => setActiveTab('gestione')} className={`flex-1 text-sm font-medium py-2 px-3 rounded-md transition-all ${activeTab === 'gestione' ? 'bg-white text-foreground shadow-sm' : 'text-muted-foreground hover:text-foreground'}`} data-id="element-1670">
          Gestione
        </button>
        <button onClick={() => setActiveTab('opportunita')} className={`flex-1 text-sm font-medium py-2 px-3 rounded-md transition-all relative ${activeTab === 'opportunita' ? 'bg-white text-foreground shadow-sm' : 'text-muted-foreground hover:text-foreground'}`} data-id="element-1671">
          Opportunità
          <span className="ml-1.5 inline-flex items-center justify-center w-5 h-5 text-[10px] font-bold bg-[#FF4080] text-white rounded-full" data-id="element-1672">
            6
          </span>
        </button>
      </div>

      {/* TAB: Gestione */}
      {activeTab === 'gestione' && <>
          {/* In corso / Prossime */}
          <div className="mb-8" data-id="element-1673">
            <div className="text-xs text-muted-foreground uppercase tracking-wider font-medium mb-3" data-id="element-1674">
              In corso e prossime
            </div>

            <div className="space-y-3" data-id="element-1675">
              {prossimePulizie.map(pulizia => {
            const isInProgress = pulizia.status === 'in_corso';
            return <div key={pulizia.id} className="bg-white border border-border rounded-xl p-4 hover:border-foreground/20 transition-colors cursor-pointer" data-id="element-1676">
                    <div className="flex justify-between items-start mb-3" data-id="element-1677">
                      <div data-id="element-1678">
                        <h3 className="text-sm font-semibold text-foreground" data-id="element-1679">
                          {pulizia.property}
                        </h3>
                        <div className="flex items-center gap-3 mt-1 text-xs text-muted-foreground" data-id="element-1680">
                          <span className="flex items-center gap-1" data-id="element-1681">
                            <Calendar size={12} data-id="element-1682" />
                            {pulizia.date}
                          </span>
                          <span className="flex items-center gap-1" data-id="element-1683">
                            <Clock size={12} data-id="element-1684" />
                            {pulizia.time}
                          </span>
                        </div>
                      </div>
                      <span className={`text-[10px] font-medium px-2 py-1 rounded-full border ${isInProgress ? 'bg-blue-50 text-blue-700 border-blue-100' : 'bg-muted text-muted-foreground border-border'}`} data-id="element-1685">
                        {isInProgress ? '● In corso' : 'Pianificata'}
                      </span>
                    </div>

                    <div className="flex items-center justify-between" data-id="element-1686">
                      <div className="flex items-center gap-2" data-id="element-1687">
                        {pulizia.cleanerImg ? <img src={pulizia.cleanerImg} alt={pulizia.cleaner} className="w-7 h-7 rounded-full object-cover" data-id="element-1688" /> : <div className="w-7 h-7 rounded-full bg-muted flex items-center justify-center" data-id="element-1689">
                            <User size={14} className="text-muted-foreground" data-id="element-1690" />
                          </div>}
                        <span className="text-xs text-muted-foreground" data-id="element-1691">
                          {pulizia.cleaner}
                        </span>
                      </div>
                      <ChevronRight size={16} className="text-muted-foreground" data-id="element-1692" />
                    </div>
                  </div>;
          })}
            </div>
          </div>

          {/* Completate */}
          <div className="mb-6" data-id="element-1693">
            <div className="text-xs text-muted-foreground uppercase tracking-wider font-medium mb-3" data-id="element-1694">
              Completate di recente
            </div>

            <div className="space-y-3" data-id="element-1695">
              {pulizieCompletate.map(pulizia => <div key={pulizia.id} className="bg-white border border-border rounded-xl p-4 flex items-center justify-between hover:border-foreground/20 transition-colors cursor-pointer" data-id="element-1696">
                  <div data-id="element-1697">
                    <h3 className="text-sm font-medium text-foreground mb-1" data-id="element-1698">
                      {pulizia.property}
                    </h3>
                    <div className="flex items-center gap-3 text-xs text-muted-foreground" data-id="element-1699">
                      <span className="flex items-center gap-1" data-id="element-1700">
                        <Calendar size={12} data-id="element-1701" />
                        {pulizia.date}
                      </span>
                      <span className="flex items-center gap-1" data-id="element-1702">
                        <Clock size={12} data-id="element-1703" />
                        {pulizia.duration}
                      </span>
                    </div>
                  </div>

                  <div className="flex items-center gap-4" data-id="element-1704">
                    <div className="flex flex-col items-end" data-id="element-1705">
                      <span className="text-[10px] text-muted-foreground uppercase tracking-wider font-medium mb-0.5" data-id="element-1706">
                        AI Check
                      </span>
                      <span className="inline-flex items-center gap-1 text-xs font-bold text-emerald-600 bg-emerald-50 px-2 py-1 rounded-md border border-emerald-100" data-id="element-1707">
                        <CheckCircle size={12} data-id="element-1708" />
                        {pulizia.aiScore}/100
                      </span>
                    </div>
                    <ChevronRight size={16} className="text-muted-foreground" data-id="element-1709" />
                  </div>
                </div>)}
            </div>
          </div>
        </>}

      {/* TAB: Opportunità */}
      {activeTab === 'opportunita' && <>
          {/* Pulse Banner */}
          <div className="mb-6" data-id="element-1710">
            <ZonePulseWidget data-id="element-1711" />
          </div>

          {/* Sharing Opportunities */}
          <div className="mb-8" data-id="element-1712">
            <SharingOpportunitiesWidget data-id="element-1713" />
          </div>

          {/* Come funziona lo sharing - Dismissable */}
          {showTutorial && <div className="mb-8 bg-white border border-border rounded-xl p-4" data-id="element-1714">
              <div className="flex items-center justify-between mb-3" data-id="element-1715">
                <div className="flex items-center gap-2" data-id="element-1716">
                  <Sparkles className="text-[#FF4080]" size={16} data-id="element-1717" />
                  <span className="text-sm font-medium text-foreground" data-id="element-1718">
                    Come funziona lo sharing
                  </span>
                </div>
                <button onClick={() => setShowTutorial(false)} className="p-1 hover:bg-muted rounded-full transition-colors" data-id="element-1719">
                  <X size={16} className="text-muted-foreground" data-id="element-1720" />
                </button>
              </div>

              <div className="flex flex-col gap-3" data-id="element-1721">
                <div className="flex items-center gap-3" data-id="element-1722">
                  <span className="w-6 h-6 rounded-full bg-muted text-muted-foreground flex items-center justify-center text-xs font-semibold shrink-0" data-id="element-1723">
                    1
                  </span>
                  <span className="text-sm text-muted-foreground" data-id="element-1724">
                    Aggreghiamo le richieste nella stessa zona
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-1725">
                  <span className="w-6 h-6 rounded-full bg-muted text-muted-foreground flex items-center justify-center text-xs font-semibold shrink-0" data-id="element-1726">
                    2
                  </span>
                  <span className="text-sm text-muted-foreground" data-id="element-1727">
                    Percorso ottimizzato per il cleaner
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-1728">
                  <span className="w-6 h-6 rounded-full bg-muted text-muted-foreground flex items-center justify-center text-xs font-semibold shrink-0" data-id="element-1729">
                    3
                  </span>
                  <span className="text-sm text-muted-foreground" data-id="element-1730">
                    Meno spostamenti → prezzo più basso per te
                  </span>
                </div>
              </div>
            </div>}
        </>}

      {/* Wizard Modal */}
      <PianificaPuliziaWizard isOpen={isWizardOpen} onClose={() => setIsWizardOpen(false)} data-id="element-1731" />
    </MobileLayout>;
}